import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useModalData } from '../../../components/modals/ModalsContext'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('screens')
  const { id, isCloning } = useModalData() || {}
  const isEditing = id > 0
  const context = isCloning ? 'cloning' : isEditing ? 'edit' : undefined
  const title = t('title', { context })

  return (
    <>
      <Col flex={1}>
        <Title size="h5" bold>
          {title}
        </Title>
      </Col>

      <LineSeparator weight={2} />
      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
